"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var InputGroup_1 = require("../InputGroup/InputGroup");

var Select_1 = require("../Select/Select");

var date_1 = require("../utils/date");

var withDefaultValue_1 = require("../decorators/withDefaultValue");

var handleEvent_1 = require("../assets/handleEvent");

var baseProps_1 = require("../assets/baseProps");

var withStyles_1 = require("../decorators/withStyles");

var DateSelect_styles_1 = require("./DateSelect.styles");

var classNames = require("classnames");

var DAY = 'day';
var MONTH = 'month';
var YEAR = 'year';

var DateSelect =
/** @class */
function (_super) {
  __extends(DateSelect, _super);

  function DateSelect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      selectActive: void 0
    };

    _this.changeDay = function (dayValue) {
      var onChange = _this.props.onChange;
      var dayValueInt = parseInt(dayValue, 10);
      handleEvent_1.handleEvent(onChange, {
        day: dayValueInt,
        month: _this.monthSelectValue,
        year: _this.yearSelectValue
      });
    };

    _this.changeMonth = function (monthValue) {
      var monthValueInt = parseInt(monthValue, 10);

      _this.fixDate(monthValueInt, _this.yearSelectValue);
    };

    _this.changeYear = function (yearValue) {
      var yearValueInt = parseInt(yearValue, 10);

      _this.fixDate(_this.monthSelectValue, yearValueInt);
    };

    _this.fixDate = function (month, year) {
      var onChange = _this.props.onChange;
      var maxDay = date_1.default(month, year);
      var fixedDay = _this.daySelectValue > maxDay ? maxDay : _this.daySelectValue;
      handleEvent_1.handleEvent(onChange, {
        day: fixedDay,
        month: month,
        year: year
      });
    };

    _this.daySelectFocus = function () {
      var onFocus = _this.props.onFocus;
      handleEvent_1.handleEvent(onFocus);

      _this.setState({
        selectActive: DAY
      });
    };

    _this.monthSelectFocus = function () {
      var onFocus = _this.props.onFocus;
      handleEvent_1.handleEvent(onFocus);

      _this.setState({
        selectActive: MONTH
      });
    };

    _this.yearSelectFocus = function () {
      var onFocus = _this.props.onFocus;
      handleEvent_1.handleEvent(onFocus);

      _this.setState({
        selectActive: YEAR
      });
    };

    _this.onBlur = function () {
      var onBlur = _this.props.onBlur;
      handleEvent_1.handleEvent(onBlur);

      _this.setState({
        selectActive: void 0
      });
    };

    return _this;
  }

  Object.defineProperty(DateSelect.prototype, "dayOptions", {
    get: function get() {
      return date_1.getDayOptions(this.monthSelectValue, this.yearSelectValue);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateSelect.prototype, "monthOptions", {
    get: function get() {
      return date_1.monthOptions;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateSelect.prototype, "yearOptions", {
    get: function get() {
      return date_1.yearOptions;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateSelect.prototype, "daySelectValue", {
    get: function get() {
      var value = this.props.value;
      return value && value.day || void 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateSelect.prototype, "monthSelectValue", {
    get: function get() {
      var value = this.props.value;
      return value && value.month || void 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateSelect.prototype, "yearSelectValue", {
    get: function get() {
      var value = this.props.value;
      return value && value.year || void 0;
    },
    enumerable: true,
    configurable: true
  });

  DateSelect.prototype.render = function () {
    var selectActive = this.state.selectActive;
    var _a = this.props,
        error = _a.error,
        testId = _a.testId,
        id = _a.id,
        maxHeightSelect = _a.maxHeightSelect,
        dangerouslyChooseActiveSelect = _a.dangerouslyChooseActiveSelect,
        classes = _a.classes,
        placeholders = _a.placeholders;
    return React.createElement(InputGroup_1.default, __assign({}, baseProps_1.default(this.props), {
      testId: testId
    }), React.createElement("div", {
      className: classNames(classes.select, classes.daySelect)
    }, React.createElement(Select_1.default, {
      menuMaxHeight: maxHeightSelect,
      testId: testId && testId + "__day",
      id: id && id + "__day",
      placeholder: placeholders && placeholders.dayPlaceholder,
      options: this.dayOptions,
      onChange: this.changeDay,
      value: "" + this.daySelectValue,
      onFocus: this.daySelectFocus,
      onBlur: this.onBlur,
      invalid: !!error && selectActive !== DAY,
      autoFocus: dangerouslyChooseActiveSelect === DAY,
      openOnFocus: dangerouslyChooseActiveSelect === DAY
    })), React.createElement(Select_1.default, {
      menuMaxHeight: maxHeightSelect,
      testId: testId && testId + "__month",
      id: id && id + "__month",
      placeholder: placeholders && placeholders.monthPlaceholder,
      options: this.monthOptions,
      onChange: this.changeMonth,
      value: "" + this.monthSelectValue,
      onFocus: this.monthSelectFocus,
      onBlur: this.onBlur,
      invalid: !!error && selectActive !== MONTH,
      autoFocus: dangerouslyChooseActiveSelect === MONTH,
      openOnFocus: dangerouslyChooseActiveSelect === MONTH
    }), React.createElement("div", {
      className: classNames(classes.select, classes.yearSelect)
    }, React.createElement(Select_1.default, {
      menuMaxHeight: maxHeightSelect,
      testId: testId && testId + "__year",
      id: id && id + "__year",
      placeholder: placeholders && placeholders.yearPlaceholder,
      options: this.yearOptions,
      onChange: this.changeYear,
      value: "" + this.yearSelectValue,
      onFocus: this.yearSelectFocus,
      onBlur: this.onBlur,
      invalid: !!error && selectActive !== YEAR,
      autoFocus: dangerouslyChooseActiveSelect === YEAR,
      openOnFocus: dangerouslyChooseActiveSelect === YEAR
    })));
  }; // при изменении месяца нам нужно менять количество дней в месяце
  // так же необходимо учесть високосный год


  DateSelect.getDerivedStateFromProps = function (props, state) {
    var value = props.value,
        onChange = props.onChange;

    if (!value) {
      return null;
    }

    var maxDay = date_1.default(value.month, value.year);

    if (value.day > maxDay) {
      handleEvent_1.handleEvent(onChange, __assign(__assign({}, value), {
        day: maxDay
      }));
      return null;
    }

    return null;
  };

  DateSelect = __decorate([withDefaultValue_1.withDefaultValue, withStyles_1.withStyles(DateSelect_styles_1.dateSelectBodyStyles)], DateSelect);
  return DateSelect;
}(React.PureComponent);

exports.default = DateSelect;